import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmContentError = ({
  message = 'componentErrorAlert.genericError_jsx'
} = {}) => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "403",
    illustration: "errors/general",
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: message,
        options: {
          href: window.location.href
        },
        elements: {
          Link
        }
      })
    })
  });
};
export default CrmContentError;